import { useRequestOauthToken } from "@tandemdiabetes/sugarmate-api-react-client"
import type { AxiosRequestConfig } from "axios"
import { isAxiosError } from "axios"
import { useMemo } from "react"

import { useAuthContext } from "../AuthContext"

const clientId: string = process.env.REACT_APP_SUGARMATE_OAUTH_CLIENT_ID ?? ""

// returns a function that refreshes the access token
export function useRefreshAccessToken(baseURL?: string) {
  const {
    isRefreshingRef,
    setIsRefreshing,
    refreshAuthCookie,
    clearAuthCookie,
  } = useAuthContext()

  const requestOauthToken = useRequestOauthToken(baseURL)

  return useMemo(
    () => !requestOauthToken
      ? undefined
      : async (token: string, config?: AxiosRequestConfig) => {
        if (isRefreshingRef.current) {
          return
        }

        try {
          setIsRefreshing(true)
          const response = await requestOauthToken(
            {
              refresh_token: token,
              client_id: clientId,
              grant_type: "refresh_token",
            },
            config,
          )

          refreshAuthCookie(response.data)
          setIsRefreshing(false)
        } catch (e) {
          // in the case of 400, 401, or 403 log the user out
          if (isAxiosError(e)) {
            if (
              e.response?.status === 401 ||
              e.response?.status === 400 ||
              e.response?.status === 403
            ) {
              clearAuthCookie()
            }
          }

          setIsRefreshing(false)
          throw e
        }
      },
    [
      requestOauthToken,
      setIsRefreshing,
      isRefreshingRef,
      refreshAuthCookie,
      clearAuthCookie,
    ],
  )
}
